import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var RatingSmall = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M8 0l2.087 5.565H16L11.13 9.74 13.217 16 8 12.174 2.783 16 4.87 9.74 0 5.564h5.913z" })), '0 0 16 16', 'RatingSmall');
//# sourceMappingURL=RatingSmall.js.map